import { render, staticRenderFns } from "./AvailabilityCard.vue?vue&type=template&id=f45ce84e&scoped=true&"
import script from "./AvailabilityCard.vue?vue&type=script&lang=js&"
export * from "./AvailabilityCard.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityCard.vue?vue&type=style&index=0&id=f45ce84e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ce84e",
  null
  
)

export default component.exports